const emailCampaignsApi = process.env.VUE_APP_EMAIL_CAMPAIGNS_API?.replace(/\/$/, '') || '';
export const EMAIL_CAMPAIGNS_API_URL = emailCampaignsApi ? `${emailCampaignsApi}` : '';
export function campaignActionUrl(id) {
    return `${EMAIL_CAMPAIGNS_API_URL}/campaigns/${encodeURIComponent(String(id))}`;
}
export function campaignStatusUrl(id) {
    return `${EMAIL_CAMPAIGNS_API_URL}/campaigns/${encodeURIComponent(String(id))}/status`;
}
export function campaignsUrl() {
    return `${EMAIL_CAMPAIGNS_API_URL}/campaigns`;
}
